import { SNSPlatform } from "../../../core/sns-platform";
import { buildFacebookEmbedNode } from "./facebook-embed-render";
import { buildYouTubeEmbedNode } from "./youtube-embed-render";
import { InstagramEmbedRender } from "./instagram-embed-render";
import { TikTokEmbedRender } from "./tiktok-embed-render";
import { buildXEmbedNode, ensureXEmbedWidgetsLoadedAndRefresh } from "./x-embed-render";
import { Roles } from "../../../../constants/roles";
import type { DetectedLinksMap } from "../../../core/sns-detector";

export class SnsEmbedRender {
    private static addMaximizeOverlay(embed: HTMLElement, url: string, platform: string): void {
        embed.setAttribute("data-sns-url", url);
        embed.setAttribute("data-sns-platform", platform);

        const overlay = document.createElement("div");
        overlay.className = "sns-embed-maximize-overlay";
        overlay.setAttribute("data-role", Roles.MAXIMIZE_VIEWER_OVERLAY);
        overlay.setAttribute("tabindex", "0");
        overlay.setAttribute("role", "button");
        overlay.setAttribute("aria-label", "クリックして拡大表示");
        embed.appendChild(overlay);
    }

    public static appendEmbedsForDetectedLinks(contentElement: HTMLElement, detectedLinks: DetectedLinksMap): void {
        if (!(contentElement instanceof HTMLElement)) return;

        Object.keys(detectedLinks || {}).forEach((platform) => {
            const links = detectedLinks[platform];
            if (!Array.isArray(links)) return;

            links.forEach((linkObj) => {
                const url = String(linkObj?.url || "");
                if (!url) return;

                if (platform === SNSPlatform.YOUTUBE) {
                    const embed = buildYouTubeEmbedNode(url);
                    if (embed) {
                        this.addMaximizeOverlay(embed, url, platform);
                        contentElement.appendChild(embed);
                    }
                } else if (platform === SNSPlatform.FACEBOOK) {
                    const embed = buildFacebookEmbedNode(url, { showText: true, width: 500, height: 600 });
                    if (embed) {
                        this.addMaximizeOverlay(embed, url, platform);
                        contentElement.appendChild(embed);
                    }
                } else if (platform === SNSPlatform.INSTAGRAM) {
                    const embed = InstagramEmbedRender.generateInstagramEmbed(url);
                    if (embed) {
                        this.addMaximizeOverlay(embed, url, platform);
                        contentElement.appendChild(embed);
                    }
                } else if (platform === SNSPlatform.TIKTOK) {
                    const embed = TikTokEmbedRender.generateTikTokEmbed(url);
                    if (embed) {
                        this.addMaximizeOverlay(embed, url, platform);
                        contentElement.appendChild(embed);
                    }
                } else if (platform === SNSPlatform.X) {
                    const embed = buildXEmbedNode(url);
                    this.addMaximizeOverlay(embed, url, platform);
                    contentElement.appendChild(embed);
                    ensureXEmbedWidgetsLoadedAndRefresh(embed);
                }
            });
        });
    }
}
